import React, { Component } from 'react';
import firebase from 'firebase';
import styled from 'styled-components';

import UserItem from './UserItem';

const RootContainer = styled.div`
	background-color: #ffffff;
	border-radius: 5px;
	display: flex;
	padding: 20px;
	flex-direction: column;
`;

const HeadlineContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

const HeadLine = styled.h2`
	max-width: 400px;
	width: 100%;
`;

const UserItemContainer = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	height: 50px;
`;

class User extends Component {
	constructor() {
		super();
		this.state = {
			users: []
		};
	}

	fetchAllUsers = async () => {
		const db = firebase.firestore();
		const ref = await db.collection('users').where('isMod', '==', false).get();
		const allUsers = [];
		ref.forEach((item) => {
			const userData = { id: item.id, ...item.data() };
			allUsers.push(userData);
		});

		this.setState({ users: allUsers });

		console.log('ref', ref);
	};

	componentDidMount() {
		this.fetchAllUsers();
	}

	render() {
		return (
			<RootContainer>
				<HeadlineContainer>
					<HeadLine>Email</HeadLine>
					<HeadLine>Code</HeadLine>
					<div>Generate</div>
				</HeadlineContainer>
				{this.state.users.map((user, index) => {
					console.log('user', user);
					console.log('even', index % 2);
					return (
						<UserItemContainer key={index}>
							<UserItem userId={user} odd={index % 2} />
						</UserItemContainer>
					);
				})}
			</RootContainer>
		);
	}
}

export default User;
